import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function InstallPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const installApp = async () => {
      const code = searchParams.get('code');
      const clientId = searchParams.get('client_id') || 'demo_client_id';
      const clientSecret = searchParams.get('client_secret') || 'demo_secret';

      if (!code) {
        toast.error('Código de autorización no encontrado');
        navigate('/');
        return;
      }

      try {
        const response = await axios.post(`${API}/auth/tiendanube/install`, {
          code,
          client_id: clientId,
          client_secret: clientSecret
        });

        const storeData = response.data;
        
        // Save store_id to localStorage
        localStorage.setItem('store_id', storeData.store_id);
        localStorage.setItem('store_name', storeData.store_name || '');
        
        toast.success('¡Aplicación instalada correctamente!');
        
        // Redirect to settings to configure Sirv
        navigate('/settings?first_time=true');
      } catch (error) {
        console.error('Error installing app:', error);
        toast.error('Error al instalar la aplicación');
        navigate('/');
      }
    };

    installApp();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-zinc-50" data-testid="install-page">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto mb-4" data-testid="install-loader" />
        <h2 className="text-2xl font-bold text-zinc-800 mb-2">Instalando aplicación...</h2>
        <p className="text-zinc-600">Por favor espera mientras configuramos todo</p>
      </div>
    </div>
  );
}